import React, { Component } from 'react';

import { 
  Modal, Toast ,TextField, Thumbnail, Select, Button,Popover,Card,Banner,Badge
} from '@shopify/polaris';

import {
  DeleteIcon
} from '@shopify/polaris-icons';
import { reqGetLinkingInfo,reqGetAliExpressData,reqPostLinkingData } from '../../../../../api';
import intl from '../../../../../i18n/intl';
import "./index.css";


class LinkingAliExpressProductModal extends Component {

    constructor(props) {
      super(props);
      this.state = {
        ModalShow: (props.show===undefined)?false:props.show,
        recordKey: props.recordKey,

        // 输入速卖通产品链接或者ID
        aliExpressUrlOrId: '',

        loadingPage: false,
        isFillAll: false,
        saveLoading: false,
        searchButtonLoading: false,
        popoverActive: false,

        // shopify产品详情数据
        shopifyProductData: '',
        variantList: <tr></tr>,
        // 链接速卖通的产品数据
        aliProductData: '',
        // 速卖通产品变体数据
        aliVariants: [{label: "Select a variant", value: "0", stock: "--"}],

      };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        ModalShow: (nextProps.show===undefined)?false:nextProps.show,
        recordKey: nextProps.recordKey,
        aliExpressUrlOrId: '',

        loadingPage: false,
        isFillAll: false,
        saveLoading: false,
        searchButtonLoading: false,
        popoverActive: false,

        // shopify产品详情数据
        shopifyProductData: '',
        variantList: <tr></tr>,
        // 链接速卖通的产品数据
        aliProductData: '',
        // 速卖通产品变体数据
        aliVariants: [{label: "Select a variant", value: "0", stock: "--"}],


      },()=>{
        this.initData();
      });
    }

    //进入页面调用接口
    componentDidMount () {
      this.initData();
    }


    //提示弹窗
    toggleToast = (showToastText, showToastIserror=false) => {
      this.setState(({ showToast }) => ({
        showToast: !showToast,
        showToastText: showToastText,
        showToastIserror: showToastIserror
      }));
    };

    // 初始化数据
    initData = async() => {
      this.setState({ loadingPage: true });
      const params = {
        id: this.props.id,
        sid: this.props.sid
      }
      const response = await reqGetLinkingInfo(params)
      this.setState({ loadingPage: false });

      if(response.code==='200'){
        this.setState({
          shopifyProductData: response.data,
          aliExpressUrlOrId: (response.ali_id !== 0) ? response.ali_id : ''
        },()=>{
          this.updatePageDetail();

          // 获取速卖通产品
          if(response.ali_id !== 0){
            this.handleGetDataFromAliExpress();
          }
        });

      }else if(response.code==='201'){  // 之前有数据的
        
        this.toggleToast(response.msg, false);
        // 更新父组件页面
        this.props.updateCallBackFun({recordKey: this.props.recordKey});

        // 关闭弹窗
        this.handleChangeModal();
      }else{
        this.toggleToast(response.msg);
      }

    }

    // 更新页面数据
    updatePageDetail(){
      let data = this.state.shopifyProductData;
      let aliVariantsData = this.state.aliVariants;
      let stockArray = [];
      for(let i=0; i<aliVariantsData.length; i++){
        stockArray[aliVariantsData[i].value] = aliVariantsData[i].stock;
      }

      let variantHTML = '';
      if(data !== ''){
        let variantData = data.variants;
        if(variantData.length > 0){
          variantHTML = variantData.map((item,key) => {
            let variantImage = (item.image_url !== '') ? item.image_url : '/default_image.png';
           
            let trHtml = (
              <tr key={key}>
                <td>
                  <div className="Variant_Box">
                    <div className="Variant_Image">
                      <Thumbnail
                        size="small"
                        source={variantImage}
                        alt="product title"
                      />
                    </div>
                    <div className="Variant_Title">
                      {item.variant_title}
                    </div>
                  </div>
                </td>
                <td>
                  <Select
                    label="AliExpress product sku"
                    labelHidden
                    options={aliVariantsData}
                    onChange={this.handleSelectChange.bind(this,key)}
                    value={String(item.ali_variant_id)}
                  />
                </td>
                <td style={{textAlign:'center'}}>{stockArray[item.ali_variant_id]}</td>
              </tr>
            )
            
            return (
              trHtml
            );
          });

        } else {
          variantHTML = <tr style={{textAlign:'center'}}><td colSpan="3">Unable to get product variant data, please check it.</td></tr>;
        }

      }else{
        variantHTML = <tr style={{textAlign:'center'}}><td colSpan="3">It can not get data, please try again.</td></tr>;
      }

      this.setState({
        variantList: variantHTML
      });
    }

    // 弹窗控制
    handleChangeModal = () =>{
      this.setState({
        ModalShow:!this.state.ModalShow,
      });
    }

    // input change
    handleInputChange = (field,value) =>{
      this.setState({
        [field]:value
      });
    }

    // clean input
    handleClearButtonClick =()=>{
      this.setState({
        aliExpressUrlOrId: ''
      });
    }

    // 获取速卖通产品
    handleGetDataFromAliExpress = async() =>{
      if(this.state.aliExpressUrlOrId === ''){
        return false;
      }

      this.setState({ searchButtonLoading: true });
      const params = {
        value: this.state.aliExpressUrlOrId,
      }
      const response = await reqGetAliExpressData(params)
      this.setState({ searchButtonLoading: false });
      if(response.code ==='200'){
        this.toggleToast(response.msg, false);

        let aliExpressVariants = response.variants;

        // START 变体匹配
        let shopifyData = this.state.shopifyProductData;
        let shopifyVariants = shopifyData.variants;
        let isFillAllVariants = true;
        for(let i=0; i<shopifyVariants.length; i++){
          // variant_title
          for(let j=0; j<aliExpressVariants.length; j++){
            // 将变体标题全部换成小写再对比
            let s_variant_title = shopifyVariants[i].variant_title.toLowerCase();
            let ali_variant_title = aliExpressVariants[j].label.toLowerCase();
            if(s_variant_title === ali_variant_title){
              shopifyVariants[i].ali_variant_id = aliExpressVariants[j].value;
            }else{
              isFillAllVariants = false;
            }
          }
        }
        // END 变体匹配

        this.setState({
          aliExpressUrlOrId: '',
          aliProductData: response.data,
          aliVariants: aliExpressVariants,
          shopifyProductData: shopifyData,
          isFillAll: isFillAllVariants
        },()=>{
          this.updatePageDetail();
        });

      }else{
        this.toggleToast(response.msg);
      }
    }

    // remove 提示
    togglePopoverActive = () =>{
      this.setState({
        popoverActive:!this.state.popoverActive,
      });
    }

    // 移除速卖通产品
    handleRemoveAliExpressData = () =>{
      // 将之前做的匹配的：速卖通变体ID移除
      let data = this.state.shopifyProductData;
      let variantData = data.variants;
      for(let i=0; i<variantData.length; i++){
        variantData[i].ali_variant_id = 0;
      }
      
      this.setState({
        shopifyProductData: data,
        aliProductData: '',
        aliVariants: [{label: "Select a variant", value: "0", stock: "--"}],
        popoverActive: false
      },()=>{
        this.updatePageDetail();
      });
    }

    // Select change
    handleSelectChange =(recordKey,value)=>{
      let data = this.state.shopifyProductData;
      let variantData = data.variants;
      variantData[recordKey].ali_variant_id = value;

      let isFillAllVariants = true;
      for (let index = 0; index < variantData.length; index++) {
        if(variantData[index].ali_variant_id === 0){
          isFillAllVariants = false;
          break;
        }
      }

      this.setState({
        shopifyProductData: data,
        isFillAll: isFillAllVariants
      },()=>{
        this.updatePageDetail();
      });
    }

    // 产品数据对应 确认
    handleSaveLinkingProduct = async() =>{
      // 检测如果没有完全匹配完所有的变体，不允许更新
      let data = this.state.shopifyProductData;
      if(data === ''){
        return false;
      }
      let variantData = data.variants;
      let isAllow = true;
      for(let i=0; i<variantData.length; i++){
        if(variantData[i].ali_variant_id === 0){
          isAllow = false;
          break;
        }
      }

      if(!isAllow){
        this.toggleToast('Please fill all variants before save.', false);
        return false;
      }

      this.setState({
        saveLoading: true,
      });

      const params = {
        data: JSON.stringify(data),
        ali: JSON.stringify(this.state.aliProductData),
        sid: this.props.sid
      }

      const response = await reqPostLinkingData(params)
      this.setState({
        saveLoading: false,
      });
      if(response.code==='200'){
        // 更新父组件页面
        this.props.updateCallBackFun({recordKey: this.props.recordKey});

        this.toggleToast(response.msg, false);

        // 关闭弹窗
        this.handleChangeModal();

      }else{
        this.toggleToast(response.msg);
      }
    }


    render() {
        const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={()=>this.toggleToast('')} error={this.state.showToastIserror} /> : null;
        const {
            state: { 
              ModalShow, aliExpressUrlOrId,saveLoading,isFillAll,searchButtonLoading,variantList,aliProductData,popoverActive
            },
        } = this;

        let aliExpressProductContent = '';

        if(aliProductData !== ''){  // 已加载速卖通产品
          let fillAllTips = isFillAll ? '' : (
            <div>
              <Banner title="Please fill all variants before save." status="warning"></Banner>
            </div>
          )
          let aliImageUrl = (aliProductData.image_url !== '') ? aliProductData.image_url :'/default_image.png';
          aliExpressProductContent = (
            <div>
              <div>Linking with</div>
              <div className="Original_Product_Box">
                <div className="Original_Product_Image">
                  <Thumbnail
                    source={aliImageUrl}
                    alt="product"
                  />
                </div>
                <div className="Original_Product_Title">
                  <a href={aliProductData.url} target="_blank" className="Polaris-Link" rel="noopener noreferrer">
                    <span>{aliProductData.title}</span>
                  </a>
                </div>
                <div className="Original_Product_Inventory">
                  <div style={{textAlign:'center',marginBottom:'5px'}} className={(aliProductData.status === 1)?"Product_Status_Badge":"Product_Status_Badge critical"}>
                    <Badge>{(aliProductData.status===1 ) ? 'For Sale' : 'Not Available'}</Badge>
                  </div>
                  {aliProductData.stockVariantsCount}
                </div>

                <div className="Linking_Product_Remove">
                  <Popover
                    active={popoverActive}
                    activator={
                      <Button icon={DeleteIcon} plain onClick={this.togglePopoverActive}></Button>
                    }
                    onClose={this.togglePopoverActive}
                  >
                    <Card
                      sectioned
                      primaryFooterAction={{content: 'Ok',onAction: this.handleRemoveAliExpressData}}
                      secondaryFooterActions={[
                        {content: 'Cancel', onAction: this.togglePopoverActive },
                      ]}
                    >
                      Delete this product?
                    </Card>
                  </Popover>
                </div>
              </div>
               {/* 匹配变体提示 */}
              {fillAllTips}
            </div>
          );

        }else{
          aliExpressProductContent = (
            <div className="">
              <TextField
                label="Linking with"
                value={String(aliExpressUrlOrId)}
                onChange={this.handleInputChange.bind(this,'aliExpressUrlOrId')}
                clearButton
                onClearButtonClick={this.handleClearButtonClick}
                connectedRight={
                  <Button 
                  variant='primary' 
                    size="medium"
                    onClick={this.handleGetDataFromAliExpress}
                    loading={searchButtonLoading}
                  >
                    Get product
                  </Button>
                }
                placeholder="Paste AliExpress product url or id here"
              />
            </div>
          )
        }

        const ModalContent = (
          <section>
            {/* 速卖通产品信息 */}
            {aliExpressProductContent}

            <div className="Linking_Product_Table">
              <table style={{width:'100%'}}>
                  <thead>
                    <tr>
                      <th style={{textAlign:'left'}}>Shopify product</th>
                      <th style={{textAlign:'center'}}>AliExpress product</th>
                      <th style={{textAlign:'center'}}>AliExpress Inventory</th>
                    </tr>
                  </thead>
                  <tbody>

                    {/* 变体列表 */}
                    {variantList}

                  </tbody>
                </table>
            </div>
          </section>
        );
      
        return (
            <div>
              <Modal
                open={ModalShow} 
                onClose={this.handleChangeModal} 
                title={intl.get("Linking product")}
                primaryAction={{
                  content: intl.get("Save"),
                  onAction: this.handleSaveLinkingProduct,
                  loading: saveLoading
                }} 
                secondaryActions={[{
                  content: intl.get("Cancel"),
                  onAction: this.handleChangeModal
                }]}
                loading={this.state.loadingPage}
                size='large'
              >
                <Modal.Section>
                  
                  {/* 产品数据对应内容 */}
                  {ModalContent}

                </Modal.Section>
              </Modal>

              { toastMarkup }
            </div>
        );
    }
}

export default LinkingAliExpressProductModal;